import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'flex w-[80px] select-none items-center justify-center gap-1 rounded-[3px] px-2 pb-[3px] pt-[5px] text-sm leading-none tracking-[-0.42px]',
  {
    variants: {
      variant: {
        orange: 'bg-orange-100 border border-orange-600 text-orange-800',
        gray: 'border border-gray-600 bg-gray-100 text-gray-700',
        green: 'border-green-600 border bg-green-400 text-green-900',
        blue: 'bg-blue-700 text-white',
        red: 'bg-red-700 text-white',
        blueLight: 'border border-blue-300 bg-blue-100 text-blue-800',
        greenLight: 'border border-green-700 bg-green-100 text-green-900',
      },
    },
    defaultVariants: {
      variant: 'orange',
    },
  }
)

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

export const Badge = ({ className, variant = 'orange', ...props }: BadgeProps) => (
  <div className={cn(badgeVariants({ variant }), className)} {...props} />
)
